import React from 'react';
import * as C from "../componentsM/index";

const Scholarship = () => {
  return (
    <>
      <C.Hero title={"Merit-Based Scholarships"} image={"/hero/scholarship.jpg"} />
      
      <section className='p-4 md:p-10'>
        {/* Scholarship Details */}
        <div >
          
          <p className="text-lg mb-6">The quoted percentages below are only applicable to tuition fees.</p>

          {/* IGCSE/O-Levels Section */}
          <h3 className="text-xl font-semibold mb-4">A) IGCSE/O-Levels</h3>
          <p className="mb-4">
  Two conditions to be met for the award of merit scholarship:
</p>
<ol className="list-decimal ml-6 mb-6">
  <li>Number of A*s</li>
  <li>No grade less than B</li>
</ol>

{/* IGCSE table */}
<table className="table-auto w-full border-collapse mb-10">
  <thead>
    <tr>
    <td className="border p-2">---</td>
      <th className="border p-2">0</th>
      <th className="border p-2">1</th>
      <th className="border p-2">2</th>
      <th className="border p-2">3</th>
      <th className="border p-2">4</th>
      <th className="border p-2">5</th>
      <th className="border p-2">6</th>
      <th className="border p-2">7+</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      
      <td className="border p-2">0</td>
      <td className="border p-2">---</td>
      <td className="border p-2">---</td>
      <td className="border p-2">---</td>
      <td className="border p-2">---</td>
      <td className="border p-2">40%</td>
      <td className="border p-2">60%</td>
      <td className="border p-2">80%</td>
      <td className="border p-2">100%</td>
    </tr>
    <tr>
      <td className="border p-2">1</td>
      <td className="border p-2">---</td>
      <td className="border p-2">---</td>
      <td className="border p-2">---</td>
      <td className="border p-2">40%</td>
      <td className="border p-2">60%</td>
      <td className="border p-2">80%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
    </tr>
    <tr>
      <td className="border p-2">2</td>
      <td className="border p-2">---</td>
      <td className="border p-2">---</td>
      <td className="border p-2">40%</td>
      <td className="border p-2">60%</td>
      <td className="border p-2">80%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
    </tr>
    <tr>
      <td className="border p-2">3</td>
      <td className="border p-2">---</td>
      <td className="border p-2">40%</td>
      <td className="border p-2">60%</td>
      <td className="border p-2">80%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
    </tr>
    <tr>
      <td className="border p-2">4</td>
      <td className="border p-2">40%</td>
      <td className="border p-2">60%</td>
      <td className="border p-2">80%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
    </tr>
    <tr>
      <td className="border p-2">5</td>
      <td className="border p-2">60%</td>
      <td className="border p-2">80%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
    </tr>
    <tr>
      <td className="border p-2">6</td>
      <td className="border p-2">80%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
    </tr>
    <tr>
      <td className="border p-2">7</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
    </tr>
    <tr>
      <td className="border p-2">8+</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
      <td className="border p-2">100%</td>
    </tr>
  </tbody>
</table>




          {/* IBMYP Section */}
          <h3 className="text-xl font-semibold mb-4">B) IBMYP</h3>
          <p className="mb-4">
            Two conditions to be met for the award of merit scholarship:
          </p>
          <ol className="list-decimal ml-6 mb-6">
            <li>Award of MYP certificate</li>
            <li>MYP Cumulative % award</li>
          </ol>
          
          <table className="table-auto w-full border-collapse mb-10">
            <thead>
              <tr>
                <th className="border p-2">MYP Cumulative %</th>
                <th className="border p-2">Award</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border p-2">48-49</td>
                <td className="border p-2">25%</td>
              </tr>
              <tr>
                <td className="border p-2">50-51</td>
                <td className="border p-2">50%</td>
              </tr>
              <tr>
                <td className="border p-2">52-53</td>
                <td className="border p-2">75%</td>
              </tr>
              <tr>
                <td className="border p-2">54-56</td>
                <td className="border p-2">100%</td>
              </tr>
            </tbody>
          </table>

          {/* North American GPA Section */}
          <h3 className="text-xl font-semibold mb-4">C) North American GPA (Grade 9 and Grade 10)</h3>
          <table className="table-auto w-full border-collapse mb-10">
            <thead>
              <tr>
                <th className="border p-2">GPA</th>
                <th className="border p-2">% Award</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border p-2">3.6 to less than 3.7</td>
                <td className="border p-2">25%</td>
              </tr>
              <tr>
                <td className="border p-2">3.7 to less than 3.8</td>
                <td className="border p-2">50%</td>
              </tr>
              <tr>
                <td className="border p-2">3.8 to less than 3.9</td>
                <td className="border p-2">75%</td>
              </tr>
              <tr>
                <td className="border p-2">3.9 to 4.0</td>
                <td className="border p-2">100%</td>
              </tr>
            </tbody>
          </table>

          {/* Matriculation Section */}
          <h3 className="text-xl font-semibold mb-4">D) Matriculations (All Vboards)</h3>
          <table className="table-auto w-full border-collapse mb-10">
            <thead>
              <tr>
                <th className="border p-2">First Division %</th>
                <th className="border p-2">Award</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border p-2">90%+</td>
                <td className="border p-2">100%</td>
              </tr>
              <tr>
                <td className="border p-2">80-90%</td>
                <td className="border p-2">80%</td>
              </tr>
              <tr>
                <td className="border p-2">70-80%</td>
                <td className="border p-2">60%</td>
              </tr>
            </tbody>
          </table>

          <p className="mt-6">All merit scholarships are annually reviewed and revised based on academic performance.</p>
        </div>
      </section>
    </>
  );
};

export default Scholarship;
